let config = {
  // SSO
  CLIENT_ID: "145d49f6-952b-4072-9092-fae325018c24",
  AUTHORITY: "https://login.microsoftonline.com/OWSISDemoA.onmicrosoft.com",

  //local

  // HOST_NAME: "http://localhost:3001",
  // API_BASE_URL: "http://localhost:3001/api/",
  // Frontend_BASE_URL : "http://localhost:3000",

 //dev 

 HOST_NAME: "https://otech-backend-dev-d4dvfgdxgvfpegan.westcentralus-01.azurewebsites.net/",
  API_BASE_URL: "https://otech-backend-dev-d4dvfgdxgvfpegan.westcentralus-01.azurewebsites.net/api/",
  Frontend_BASE_URL: "https://otech-dev-gkhnbmezauejguap.westcentralus-01.azurewebsites.net",

//  HOST_NAME: "https://oneworldbackend.azurewebsites.net/",
//   API_BASE_URL: "https://oneworldbackend.azurewebsites.net/api/",
//   Frontend_BASE_URL: "https://owsisdemo.azurewebsites.net",

  SHAREPOINTSITEURL: "https://owsisdemoa.sharepoint.com",
  INVALID_PASSWORD: "Invalid username and password",
  CONFIRM_PASSWORD: "Password and confirm Password didn't matched",

  // for dev
  SHAREQUESTPHRASE: "TESTSHAIN",
  SHARESPONSEPHRASE: "TESTSHAOUT",
  ACCESSCODE: "BVAqsy3vJF3OoTNMQMjU",
  MERCHANTIDENTIFIER: "ouWmOQdP",
  PURCHASEHOSTURL: "https://sbcheckout.payfort.com/FortAPI/paymentPage",
  //return_url: "http://localhost:3001/api/payment/purchase/response",
  return_url:
    "https://oneworldwebappcontainer.azurewebsites.net/api/payment/purchase/response",
  copyright: `© OneWorldSIS, Inc. ${new Date().getFullYear()} - All Rights Reserved.`,
};

export default config;
